module.exports = __webpack_public_path__ + "img/construction-3.07a09102.png";